export default __webpack_public_path__ + "static/media/encourage.084b8bd0.mp3";